import React, { useState } from 'react';
import style from '../css/NewBenefits.module.css';
import '../css/pagination.css';

import benefits from '../utils/NewBenefits';

import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';

import { MdKeyboardArrowLeft, MdKeyboardArrowRight } from 'react-icons/md';

const NewBenefits = () => {
	const [swiper, setSwiper] = useState();

	const pagination = {
		el: '.paginacion-personalizada',
		bulletClass: 'swiper-pagination-benefits',
		bulletActiveClass: 'swiper-pagination-benefits-active',
		clickable: false,
	};

	return (
		<section className={style.mainSection}>
			<div className={style.mainContainer}>
				<h1>BENEFICIOS LIBEL ACADEMY</h1>

				<div className={style.benefitsMainContainer}>
					<Swiper
						className={style.swiperBenefits}
						autoplay={{
							delay: 5000,
						}}
						slidesPerView={1}
						slidesPerGroup={1}
						spaceBetween={24}
						freeMode={true}
						onSwiper={(swiper) => setSwiper(swiper)}
						loop={true}
						pagination={pagination}
						modules={[Autoplay, Pagination]}
						breakpoints={{
							1100: {
								slidesPerView: 3,
								slidesPerGroup: 3,
							},

							700: {
								slidesPerView: 2,
								slidesPerGroup: 2,
							},
						}}
					>
						{benefits.map((e, i) => (
							<SwiperSlide className={style.swiperSlide} key={i}>
								<div className={style.benefitContainer}>
									<img src={e?.img} alt='icon1' />
									<h1>{e?.title}</h1>

									<p>{e?.body}</p>
								</div>
							</SwiperSlide>
						))}
					</Swiper>

					<div className='paginacion-personalizada'></div>
				</div>
			</div>
		</section>
	);
};

export default NewBenefits;
